import React, { useState } from 'react';

const CourseThumbnail = ({ 
  src, 
  alt, 
  className = "", 
  fallbackText = "No thumbnail",
  showOverlay = false,
  overlayContent = null 
}) => {
  const [imageError, setImageError] = useState(false);
  const [imageLoading, setImageLoading] = useState(true);

  const handleImageLoad = () => {
    setImageLoading(false);
  };

  const handleImageError = () => {
    setImageError(true);
    setImageLoading(false);
  };

  return (
    <div className={`aspect-video bg-gray-200 relative flex-shrink-0 course-thumbnail ${className}`}>
      {src && !imageError ? (
        <img 
          src={src} 
          alt={alt}
          className="w-full h-full object-cover object-center"
          onLoad={handleImageLoad}
          onError={handleImageError}
          style={{ 
            opacity: imageLoading ? 0.7 : 1,
            transition: 'opacity 0.3s ease'
          }}
        />
      ) : (
        <div className="w-full h-full flex items-center justify-center text-secondary-400 bg-gray-100">
          <div className="text-center">
            <div className="w-12 h-12 mx-auto mb-2 bg-gray-300 rounded-full flex items-center justify-center">
              <svg className="w-6 h-6 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
              </svg>
            </div>
            <p className="text-sm">{fallbackText}</p>
          </div>
        </div>
      )}
      
      {showOverlay && overlayContent && (
        <div className="absolute inset-0 bg-black bg-opacity-0 hover:bg-opacity-20 transition-all duration-200 flex items-center justify-center">
          {overlayContent}
        </div>
      )}
      
      {imageLoading && src && !imageError && (
        <div className="absolute inset-0 bg-gray-200 animate-pulse flex items-center justify-center">
          <div className="w-8 h-8 border-2 border-gray-300 border-t-primary-600 rounded-full animate-spin"></div>
        </div>
      )}
    </div>
  );
};

export default CourseThumbnail;
